import { render, staticRenderFns } from "./cgwcDetail.vue?vue&type=template&id=737b3b96&scoped=true&"
import script from "./cgwcDetail.vue?vue&type=script&lang=js&"
export * from "./cgwcDetail.vue?vue&type=script&lang=js&"
import style0 from "./cgwcDetail.vue?vue&type=style&index=0&id=737b3b96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "737b3b96",
  null
  
)

export default component.exports